export default "__VITE_ASSET__CuAZcTjw__"